module.exports = __webpack_public_path__ + "img/goDownload@2x.16131185.png";